// Official Tabler Icons (SVG helper strings)

function svg(paths: string, size = 18, className = 'tabler-icon'): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" class="${className}" width="${size}" height="${size}" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" style="vertical-align: middle; flex-shrink: 0;">${paths}</svg>`;
}

export const tablerIcons = {
  // Chart Bar (สำหรับแท็บ "วันนี้" และ กราฟ)
  chartBar: (size = 18) =>
    svg(
      '<path d="M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"/><path d="M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"/><path d="M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"/><path d="M4 20l14 0"/>',
      size
    ),

  // Activity / Pulse (สำหรับแท็บ "ความเคลื่อนไหว")
  activity: (size = 18) =>
    svg('<path d="M3 12h4l3 8l4 -16l3 8h4"/>', size),

  // Building Store (สำหรับแท็บ "สาขา")
  buildingStore: (size = 18) =>
    svg(
      '<path d="M3 21l18 0"/><path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4"/><path d="M5 21l0 -10.15"/><path d="M19 21l0 -10.15"/><path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"/>',
      size
    ),

  // Settings (สำหรับแท็บ "ตั้งค่า & แจ้งเตือน")
  settings: (size = 18) =>
    svg(
      '<path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"/><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"/>',
      size
    ),

  // Clock (สาขาที่ยังไม่ส่ง / เวลา)
  clock: (size = 18) =>
    svg('<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"/><path d="M12 7v5l3 3"/>', size),

  // Circle Check (สาขาที่ส่งแล้ว)
  circleCheck: (size = 18) =>
    svg('<path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"/><path d="M9 12l2 2l4 -4"/>', size),

  // Alert Circle (เตือนค้างส่ง)
  alertCircle: (size = 18) =>
    svg('<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"/><path d="M12 8v4"/><path d="M12 16h.01"/>', size),

  // Clipboard Check (รายงานใหม่)
  clipboardCheck: (size = 18) =>
    svg(
      '<path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"/><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"/><path d="M9 14l2 2l4 -4"/>',
      size
    ),

  // Edit / Pencil (แก้ไขรายงาน)
  edit: (size = 18) =>
    svg(
      '<path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"/><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"/><path d="M16 5l3 3"/>',
      size
    ),

  // File Text (เอกสารทั่วไป)
  fileText: (size = 18) =>
    svg(
      '<path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/><path d="M9 9l1 0"/><path d="M9 13l6 0"/><path d="M9 17l6 0"/>',
      size
    ),

  // Bell (กระดิ่งแจ้งเตือน)
  bell: (size = 18) =>
    svg(
      '<path d="M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"/><path d="M9 17v1a3 3 0 0 0 6 0v-1"/>',
      size
    ),

  // Send (ยิงทดสอบ)
  send: (size = 18) =>
    svg(
      '<path d="M10 14l11 -11"/><path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"/>',
      size
    ),

  // Info Circle (ข้อมูล)
  infoCircle: (size = 18) =>
    svg('<path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"/><path d="M12 9h.01"/><path d="M11 12h1v4h1"/>', size),

  // File Spreadsheet (Export CSV)
  fileSpreadsheet: (size = 18) =>
    svg(
      '<path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/><path d="M8 11h8v7h-8z"/><path d="M8 15h8"/><path d="M11 11v7"/>',
      size
    ),

  // Search (ค้นหา)
  search: (size = 18) =>
    svg('<path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"/><path d="M21 21l-6 -6"/>', size),

  // Refresh (อัปเดต)
  refresh: (size = 16) =>
    svg('<path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"/><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>', size),

  // Filter (กรองข้อมูล)
  filter: (size = 18) =>
    svg('<path d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.828 4.828v7l-6 2v-9l-4.828 -4.828a2 2 0 0 1 -.586 -1.414v-2.172z"/>', size),

  // Chevron Down (ขยายดูรายละเอียด)
  chevronDown: (size = 18) =>
    svg('<path d="M6 9l6 6l6 -6"/>', size),

  // Calendar (ปฏิทิน)
  calendar: (size = 18) =>
    svg('<path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"/><path d="M16 3v4"/><path d="M8 3v4"/><path d="M4 11h16"/><path d="M11 15h1"/><path d="M12 15v3"/>', size),

  // Device Mobile (อุปกรณ์)
  deviceMobile: (size = 18) =>
    svg('<path d="M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z"/><path d="M11 4h2"/><path d="M12 17v.01"/>', size)
};
